"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addNextParamToUrl = exports.COMMAND_UPDATE_COOKIE_TOKEN = void 0;

var _queryString = _interopRequireDefault(require("query-string"));

var COMMAND_UPDATE_COOKIE_TOKEN = 'ALYCE_EXTENSION_UPDATE_COOKIE_TOKEN';
exports.COMMAND_UPDATE_COOKIE_TOKEN = COMMAND_UPDATE_COOKIE_TOKEN;

var addNextParamToUrl = function addNextParamToUrl(logoutUrl, location) {
  var pathname = location.pathname,
      search = location.search;

  if (pathname === '/' && search === '') {
    return logoutUrl;
  }

  var _qs$parseUrl = _queryString.default.parseUrl(logoutUrl),
      url = _qs$parseUrl.url,
      query = _qs$parseUrl.query; // In case if next param is already presented in a returnUrl there is no need to add it again


  if (search.includes('next=')) {
    return _queryString.default.stringifyUrl({
      url,
      query: {
        returnUrl: "".concat(query.returnUrl).concat(search)
      }
    });
  }

  var next = "".concat(pathname).concat(/[^a-zA-Z0-9\-_%./?&=[\]]/.test(search) ? '' : search);

  var encodedReturnUrl = _queryString.default.stringifyUrl({
    url: query.returnUrl,
    query: {
      next
    }
  });

  return _queryString.default.stringifyUrl({
    url,
    query: {
      returnUrl: encodedReturnUrl
    }
  });
};

exports.addNextParamToUrl = addNextParamToUrl;